import React, { Component } from 'react';
import { getImportHistoryOrderDetail } from './../../../utils/orders';
import hanldeException from './../../../services/handleException';
import { convertDateFromUTC } from './../../../services/dst';
import { getImageChannel, ImportType } from './../../../constants/order';
import { iconEmpty } from './../../../services/helper';
import { Spin } from 'antd';
import './styles.css';

class ImportHistoryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: {}, // list detail 1 import history
            objItem: {},
            isLoaded: false
        };
    }

    componentDidMount() {
        this.callImportDetail();
    }

    /**
     * from props to state
     */
    static getDerivedStateFromProps(props, state) {
        return {
            objItem: props.objItem
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.isVisible !== this.props.isVisible && this.props.isVisible === true) {
            this.callImportDetail();
        }
    }

    callImportDetail = () => {
        let that = this;
        that.setState({
            details: [],
            isLoaded: false,
        });
        getImportHistoryOrderDetail(that.state.objItem.ID)
        .then(response => {
            that.setState({
                isLoaded: true,
            });
            if (response.data.code === 10001) {
                that.setState({
                    details: response.data.data
                });
            } else {
                hanldeException(response);
            }
        })
        .catch(error => {
            that.setState({
                isLoaded: true,
            });
            hanldeException(error);
        });
    }

    /**
     * render a row in table
     */
    renderRows = () => {
        return (
            this.state.details.map((item, index) => {
                return (
                    <tr key={index} className={parseInt(item.ResultType) === 1 ? 'tr-error' : 'tr-warn'}>
                        <td className="col-te">{parseInt(item.ResultType) === 1 ? 'Fatal' : 'Warning'}</td>
                        <td className="col-line">{item.ErrorLine ? 'Line: ' + item.ErrorLine : ''}</td>
                        <td className="col-col">{item.ErrorColumn ? 'Column: ' + item.ErrorColumn: ''}</td>
                        <td className="col-mess">{item.ErrorDetail}</td>
                        <td className="col-exit">{parseInt(item.ResultType) === 1 ? 'Exit' : ''}</td>
                    </tr>
                )
            })
        );
    }

    renderRowAmazonRakutenJpApi = () => {
        return (
            this.state.details.map((item, index) => {
                return (
                    <tr key={index} className={parseInt(item.ResultType) === 1 ? 'tr-error' : 'tr-warn'}>
                        <td className="col-te">{parseInt(item.ResultType) === 1 ? 'Fatal' : 'Warning'}</td>
                        <td className="col-line-rakuten">{item.ChannelOrderId}</td>
                        <td className="col-col">{item.ErrorColumn ? 'Column: ' + item.ErrorColumn : ""}</td>
                        <td className="col-mess">{item.ErrorDetail}</td>
                        <td className="col-exit">{parseInt(item.ResultType) === 1 ? 'Exit' : ''}</td>
                    </tr>
                )
            })
        );
    }

    renderRowEmpty = () => {
        return (
            <tr className="tr-empty">
                <td colSpan={4}>
                    {this.state.isLoaded ? iconEmpty('No Error') : <Spin />}
                </td>
            </tr>
        );
    }

    render() {
        let contentTblError = '';
        if (this.state.details && this.state.details.length) {
            if ( (this.state.objItem.ChannelName == "Rakuten" || this.state.objItem.ChannelName == "Amazon.co.jp") && this.state.objItem.Type == "0") {
                contentTblError = this.renderRowAmazonRakutenJpApi();
            } else {
                contentTblError = this.renderRows();
            }
        } else {
            contentTblError = this.renderRowEmpty();
        }
        
        return (
            <div>
                <h2 className="ih-title">{ImportType[this.state.objItem.Type]} Import Result - Detail</h2>
                <table className="tbl-ih-detail">
                    <thead>
                        <tr>
                            <th className="col-success" colSpan="4">{ImportType[this.state.objItem.Type]} Import
                                {parseInt(this.state.objItem.ResultType) === 1 ? ' Error' : ' Successful'}</th>
                            <th className="col-error text-center" colSpan="2">Errors</th>
                        </tr>
                        <tr className="thead-col">
                            <th className="col-date">Import Date Time</th>
                            <th className="col-chanel">Channel</th>
                            <th className="col-order text-center">Order Count</th>
                            <th className="col-import text-center">Import Count</th>
                            <th className="col-warning text-center">Warning Count</th>
                            <th className="col-fatal text-center">Fatal Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-date">
                                {convertDateFromUTC(this.state.objItem.ImportDatetime).format('MM/DD/YYYY HH:mm:ss')}
                            </td>
                            <td className="col-chanel">{getImageChannel(this.state.objItem.ChannelName)}</td>
                            <td className="col-order text-center">{this.state.objItem.OrderCount}</td>
                            <td className="col-import text-center">{this.state.objItem.ImportCount}</td>
                            <td className="col-warning text-center">{this.state.objItem.WarningCount}</td>
                            <td className="col-fatal text-center">{this.state.objItem.FatalCount}</td>
                        </tr>
                    </tbody>
                </table>

                <table className="tbl-error">
                    <colgroup>
                        <col />
                        <col />
                        <col />
                        <col />
                    </colgroup>
                    <tbody>
                        { contentTblError }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ImportHistoryDetail;


// WEBPACK FOOTER //
// ./src/containers/orders/importHistory/detail.js